import {
  getAllAwards,
  isLibraryAwardImplementation,
} from '@/modules/people/composables/pay-rates';

export function isCustomPayRate(contractId: unknown): boolean {
  if (typeof contractId !== 'number') {
    return false;
  }
  const foundAward = (getAllAwards() as Array<Record<string, unknown>>).find(
    award => award.Id === contractId
  );
  return Boolean(
    foundAward?.IsPayPolicy && !isLibraryAwardImplementation(foundAward)
  );
}
